import {WorkflowTaskId} from "./task_config";

interface BaseDataLocationObject {
  key: number | string;
}

export const valueTypes = [
  "none",
  "literal",
  "input",
  "variable",
  "context",
  "prompt",
  "task",
  "listItem",
  "asset",
  "collection_asset",
] as const;
export type ValueType = typeof valueTypes[number];

export interface ContextDataLocationObject extends BaseDataLocationObject {
  source_type: "context";
  key: number;
}

export interface InputDataLocationObject extends BaseDataLocationObject {
  source_type: "input";
  key: number;
  // Accessor into the task to get nested values if task returns an object
  value: string;
}

export interface VariableDataLocationObject extends BaseDataLocationObject {
  source_type: "variable";
  key: string;
}

export interface TaskDataLocationObject extends BaseDataLocationObject {
  source_type: "task";
  // Id of the task
  key: string;
  task: WorkflowTaskId;
  // Accessor into the task to get nested values if task returns an object
  value: string;
}

export interface PromptDataLocationObject extends BaseDataLocationObject {
  source_type: "prompt";
}

export interface LiteralDataLocationObject<T> {
  source_type: "literal";
  value: T;
}

export interface ListItemDataLocationObject<T> {
  source_type: "listItem";
  value: T;
}

export interface AssetDataLocationObject extends BaseDataLocationObject {
  source_type: "asset";
  entity_id: DataLocation<string>;
  value: DataLocation<string>;
}
export interface CollectionAssetDataLocationObject
  extends BaseDataLocationObject {
  source_type: "collection_asset";
  entity_id: DataLocation<string>;
  value: DataLocation<string>;
}

export interface EmptyDataLocationObject {
  source_type: "none";
}

export type KeyedDataLocationObject =
  | ContextDataLocationObject
  | InputDataLocationObject
  | VariableDataLocationObject
  | TaskDataLocationObject
  | PromptDataLocationObject
  | AssetDataLocationObject
  | CollectionAssetDataLocationObject;

export type DataLocation<T> =
  | LiteralDataLocationObject<T>
  | ListItemDataLocationObject<T>
  | KeyedDataLocationObject
  | EmptyDataLocationObject;

export type ChildDataLocation<T> = DataLocation<T> & {
  add_to_links: boolean;
  link_key: string;
};
